module.exports = __webpack_public_path__ + "static/media/bindOutlook1.6c6b4230.png";